export default {"src":"/_next/static/media/option2bot.e5a90564.svg","height":294,"width":246,"blurWidth":0,"blurHeight":0};